import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Container } from '@ui';
import { VAULT_DENSITIES } from '@utils/documentVault';
import { CellWrapper, RowWrapper } from './styles';

const pulse = keyframes`
  0% { opacity: 0.35; }
  50% { opacity: 0.7; }
  100% { opacity: 0.35; }
`;

const SkeletonBar = styled.div`
  height: 12px;
  width: ${({ $width }) => $width || '100%'};
  border-radius: 3px;

  background: ${({ theme }) => theme.themeColors.lowContrastBorder};
  animation: ${pulse} 1.4s ease-in-out infinite;
  animation-delay: ${({ $delay }) => $delay}ms;
`;

const SKELETON_ROW_COUNT = 8;
const COLUMN_WIDTHS = ['100%', '80%', '60%', '70%', '55%', '45%', '40%'];

/*
  Skeleton rows rather than a lone spinner: the table's shape shows up immediately, so the list
  doesn't jump when the real rows land.
*/
export const VaultLoadingRows = ({ density = VAULT_DENSITIES.comfortable }) => {
  return (
    <Container>
      {Array.from({ length: SKELETON_ROW_COUNT }).map((_, rowIndex) => (
        <RowWrapper key={rowIndex} $density={density}>
          {COLUMN_WIDTHS.map((width, columnIndex) => (
            <CellWrapper key={columnIndex}>
              <SkeletonBar $width={width} $delay={rowIndex * 60} />
            </CellWrapper>
          ))}
        </RowWrapper>
      ))}
    </Container>
  );
};
